import React from "react";
import ServiceHero from "../../components/ServiceHero";

const DigitalMarketingHome = () => (
  <ServiceHero
    eyebrow="Digital Marketing"
    title="Marketing built to"
    highlight="compound your growth."
    description="We connect strategy, content, search, and paid campaigns into one focused growth engine—so every channel works harder for your business."
    features={[
      "Full-funnel growth strategy",
      "Campaigns guided by data",
      "Clear, actionable reporting",
    ]}
    image="/Images/digitalMarHome.webp"
    imageAlt="Illustration of connected digital marketing channels on a mobile device"
    visualLabel="One connected growth engine"
    visualTitle="The right message, channel, and moment—working together."
  />
);

export default DigitalMarketingHome;
